import { render, staticRenderFns } from "./TableWorkShifts.vue?vue&type=template&id=77cc7b6a&"
import script from "./TableWorkShifts.vue?vue&type=script&lang=js&"
export * from "./TableWorkShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports